<template>
  <detail-layout ref="layout" :tableCfg="tableCfg">
    <template slot="ExtraOptions" scope="props">
      <b-button v-if="dataValid && props.rec.active_contract_id" variant="default" size="sm" @click="$router.push({name: 'contract', params: {id: props.rec.active_contract_id}})">
        <i class="fa fa-arrow-right"></i> Contract
      </b-button>
    </template>
    <template slot="FormLayout" scope="props" autocomplete="off">
      <b-form ref="form" class="offset-md-1" v-if="dataValid" autocomplete="off">
         <!-- autocomplete="off" -->
        <!-- <b-tabs small card ref="tabs" v-model="tabIndex" v-if="props.rec">
          <b-tab title="General"> -->
          <b-card no-block class="template-card" header="Student Name & Info" header-variant="template-header">
            <div class="row">
              <detail-field class="col-md-6" label="First Name" field="first_name" :rec="props.rec" :isReadOnly="isReadOnly" vvalidate="required" :validator="validator"/>
              <detail-field class="col-md-6" label="Last Name" field="last_name" :rec="props.rec" :isReadOnly="isReadOnly" vvalidate="required" :validator="validator"/>
            </div>
            <div class="row">
              <detail-field class="col-md-6" label="Street Address" field="address" :rec="props.rec" :isReadOnly="isReadOnly" vvalidate="required" :validator="validator"/>
            </div>
            <div class="row">
              <detail-field class="col-md-6" label="ZIP" field="zip" :rec="props.rec" :isReadOnly="isReadOnly" vvalidate="required" :validator="validator"/>
              <detail-field class="col-md-6" label="City" field="city" :rec="props.rec" :isReadOnly="isReadOnly" vvalidate="required" :validator="validator"/>
              <detail-field class="col-md-6" label="Country" field="cntry_id" optionListApiUrl="/countries/choice/" :rec="props.rec" :isReadOnly="isReadOnly" vvalidate="required" :validator="validator"/>
            </div>
            <div class="row">
              <detail-field class="col-md-6" label="Birthday" field="birth_date" :rec="props.rec" :isReadOnly="isReadOnly" type="simpledate" vvalidate="required" :validator="validator"/>
              <detail-field class="col-md-6" label="Gender" field="gender" :rec="props.rec" :isReadOnly="isReadOnly" vvalidate="ok" :validator="validator" :optionList="['Male', 'Female', 'Non-Binary']"/>
              <detail-field class="col-md-6" label="Citizenship 1" field="citizenship1_cntry_id" optionListApiUrl="/countries/choice/" :rec="props.rec" :isReadOnly="isReadOnly" vvalidate="ok" :validator="validator"/>
              <detail-field class="col-md-6" label="Citizenship 2" field="citizenship2_cntry_id" optionListApiUrl="/countries/choice/" :rec="props.rec" :isReadOnly="isReadOnly" vvalidate="ok" :validator="validator"/>
            </div>
            <div class="row">
              <detail-field class="col-md-6" label="Phone" field="phone" type="phone" :rec="props.rec" :isReadOnly="isReadOnly" vvalidate="ok" :validator="validator"/>
              <detail-field class="col-md-6" label="Email Address" field="email_address" type="email" :rec="props.rec" :isReadOnly="isReadOnly" vvalidate="required|email" :validator="validator"/>
              <detail-field class="col-md-6" label="Passport Nr" field="passport_number" :rec="props.rec" :isReadOnly="isReadOnly" vvalidate="ok" :validator="validator"/>
            </div>
            <div class="row">
              <detail-field class="col-md-6" label="Comments" field="comments" type="textarea" :rec="props.rec" :isReadOnly="isReadOnly" vvalidate="ok" :validator="validator"/>
              <detail-field class="col-md-6" label="Registration Fee Paid" field="registration_fee_payed" :rec="props.rec" :isReadOnly="true" type="boolean" vvalidate="ok" :validator="validator"/>
            </div>
            <div class="row">
              <detail-field class="col-md-6" label="Bank info requested" field="bankinfo_emailrequest_timestamp" field2="bankinfo_emailrequest_user" :static="true" :rec="props.rec" :isReadOnly="true" type="timestamp_user" vvalidate="ok" :validator="validator"/>
              <detail-field class="col-md-6" label="Bank info updated" field="bankinfo_updated_timestamp" field2="bankinfo_updated_user" :static="true" :rec="props.rec" :isReadOnly="true" type="timestamp_user" vvalidate="ok" :validator="validator"/>
              <detail-field class="col-md-6" label="Created" field="creation_timestamp" field2="creation_user" :static="true" :rec="props.rec" :isReadOnly="true" type="timestamp_user" vvalidate="ok" :validator="validator"/>
              <detail-field class="col-md-6" label="Last Edit" field="edit_timestamp" field2="edit_user" :static="true" :rec="props.rec" :isReadOnly="true" type="timestamp_user" vvalidate="ok" :validator="validator"/>
            </div>
          </b-card>
          <!-- </b-tab>
          <b-tab title="Payment Info"> -->
            <b-card no-block class="template-card" header="Bank Account Holder Name" header-variant="template-header">
              <div class="row">
                <detail-field class="col-md-6" label="First" field="payment_holder_first_name" :rec="props.rec" :isReadOnly="isReadOnly" vvalidate="ok" :validator="validator"/>
                <detail-field class="col-md-6" label="Last" field="payment_holder_last_name" :rec="props.rec" :isReadOnly="isReadOnly" vvalidate="ok" :validator="validator"/>
              </div>
            </b-card>
            <b-card no-block class="template-card" header="Bank Account Holder Address" header-variant="template-header">
              <div class="row">
                <detail-field class="col-md-6" label="Street + nr" field="payment_holder_address" :rec="props.rec" :isReadOnly="isReadOnly" vvalidate="ok" :validator="validator"/>
                <detail-field class="col-md-6" label="Postal code/City" field="payment_holder_zip_city" :rec="props.rec" :isReadOnly="isReadOnly" vvalidate="ok" :validator="validator"/>
                <detail-field class="col-md-6" label="Country" field="payment_holder_cntry_id" optionListApiUrl="/countries/choice/" :rec="props.rec" :isReadOnly="isReadOnly" vvalidate="ok" :validator="validator"/>
              </div>
            </b-card>
            <b-card no-block class="template-card" header="Bank Account" header-variant="template-header">
              <div class="row">
                <detail-field class="col-md-6" label="IBAN" field="payment_bank_iban" :rec="props.rec" :isReadOnly="isReadOnly" vvalidate="ok" :validator="validator"/>
                <detail-field class="col-md-6" label="Swift" field="payment_bank_swift" :rec="props.rec" :isReadOnly="isReadOnly" vvalidate="ok" :validator="validator"/>
                <detail-field class="col-md-6" label="Reference" field="payment_bank_reference" :rec="props.rec" :isReadOnly="isReadOnly" vvalidate="ok" :validator="validator"/>
              </div>
            </b-card>
            <b-card no-block class="template-card" header="Bank & Addres" header-variant="template-header">
              <div class="row">
                <detail-field class="col-md-6" label="Name" field="payment_bank_name" :rec="props.rec" :isReadOnly="isReadOnly" vvalidate="ok" :validator="validator"/>
                <detail-field class="col-md-6" label="Street + nr" field="payment_bank_address" :rec="props.rec" :isReadOnly="isReadOnly" vvalidate="ok" :validator="validator"/>
                <detail-field class="col-md-6" label="Postal code/City" field="payment_bank_zip_city" :rec="props.rec" :isReadOnly="isReadOnly" vvalidate="ok" :validator="validator"/>
                <detail-field class="col-md-6" label="Country" field="payment_bank_cntry_id" optionListApiUrl="/countries/choice/" :rec="props.rec" :isReadOnly="isReadOnly" vvalidate="ok" :validator="validator"/>
              </div>
            </b-card>
          <!-- </b-tab>
          <b-tab title="Payment Info"> -->
            <b-card no-block class="template-card" header="KIT Student Reference" header-variant="template-header">
              <div class="row">
                <detail-field class="col-md-6" label="Reference" field="university_payment_reference" :rec="props.rec" :isReadOnly="isReadOnly" vvalidate="ok" :validator="validator"/>
              </div>
            </b-card>
        </b-tabs> -->
      </b-form>
    </template>
  </detail-layout>
</template>

<script>
import DetailMixin from '../../components/DetailMixin'
import FieldDefs from './FieldDefs.js'

export default {
  name: 'student_detail',
  mixins: [DetailMixin],
  data () {
    return {
      tabIndex: 0,
      tableCfg: FieldDefs
    }
  },
  methods: {
  }
}
</script>



// WEBPACK FOOTER //
// Detail.vue?31c97c62